import { Injectable } from '@angular/core';
import { BundleItem, BundleLine, BundlePricing } from './bundle-builder.model';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from 'src/app/shared-core/services/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class BundleBuilderApiService {
  vistekUrl: string;

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    this.vistekUrl = this.appConfigService.vistekUrl;
  }

  addToCart(bundle: BundleLine[]) {
    const payload = bundle.map((b) => {
      const dto = {
        WebCode: b.item.Webcode,
        BundleId: b.item.BundleId,
        Quantity: b.quantity,
        IsAnchor: b.item.IsAnchor
      };
      return dto;
    });
    return this.http.post<number>(`${this.vistekUrl}/cart/add/bundle`, payload).toPromise();
  }

  public async getBundlePrice(bundle: BundleLine[]): Promise<number> {
    const payload = bundle.map((b) => {
      const dto = {
        WebCode: b.item.Webcode,
        BundleId: b.item.BundleId,
        Quantity: b.quantity,
      };
      return dto;
    });
    return this.http.post<number>(`${this.vistekUrl}/cart/bundle/price`, payload).toPromise();
  }

  public async getBundleItemDefinitions(bundleId: number): Promise<BundleItem[]> {
    return await this.http.get<BundleItem[]>(`${this.vistekUrl}/cart/bundle/definition/${bundleId}`).toPromise();
  }
}
